interface TechBadgeProps {
  label: string;
  active?: boolean;
}

// Small pill used for tech tags across hero, projects and skills.
export default function TechBadge({ label, active = false }: TechBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
        active
          ? "border-cyan-400/40 bg-cyan-400/10 text-cyan-300"
          : "border-soft card-bg text-soft"
      }`}
    >
      {label}
    </span>
  );
}
